<template>
  <utd-notice-dialog ref="dialog"
                     :title="title"
                     :heading="heading"
                     :body-bullets="BCDR_MESSAGE.BODY_TEXT_ARR"
                     icon-class="wkce-icon-filled-info"
                     @modal-closed="$emit('modal-closed')" />
</template>

<script lang="ts" setup>
import UtdNoticeDialog from '_acaSrc/components/shared/stdlib/UtdNoticeDialog.vue';
import { BCDR_MESSAGE } from '_acaSrc/utility/constants';
import { computed, ref } from 'vue';

const { featureName } = defineProps({
    featureName: String
});

defineEmits([ 'modal-closed' ]);

const title = computed(() => BCDR_MESSAGE.TITLE_TEXT_FN(featureName));
const heading = computed(() => BCDR_MESSAGE.HEADING_TEXT_FN(featureName));

const dialog = ref(null);
const openModal = () => {
    dialog.value.openModal();
};
const closeModal = () => {
    dialog.value.closeModal();
};

defineExpose({
    openModal,
    closeModal
});
</script>